
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import PageHead from "@/components/PageHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Check if this is a job-related 404
  const isJobRoute = location.pathname.includes('/job/');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <PageHead title="Page Not Found" />
      <div className="text-center max-w-md mx-auto px-4">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">
          {isJobRoute 
            ? "This job listing is no longer available or may have been removed."
            : "Oops! Page not found"}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="text-blue-500 hover:text-blue-700 underline">
            Return to Home
          </Link>
          {isJobRoute && (
            <Link to="/visa-sponsored-jobs" className="text-blue-500 hover:text-blue-700 underline">
              Browse All Jobs
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
